import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PatientIdentifier } from "@/Common/Models/Patient/PatientIdentifier";

import styles from "./Identifiers.module.scss";

interface OtherIdentifiersViewProps {
    identifiers: PatientIdentifier[]
}

function OtherIdentifiersView(props: OtherIdentifiersViewProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <table>
            {props.identifiers && props.identifiers.length > 0 && props.identifiers.map((id, idx) => (
                <tbody key={`otherId${idx}`} className={styles.identifiers}>
                    <tr>
                        <td className="c1">
                            <span className="form-label">{getText("OrganizationLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong data-cy="patientProfile-otherIds-organization">{id.Name}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className="c1">
                            <span className="form-label">{getText("NumberLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong data-cy="patientProfile-otherIds-number">{id.Number}</strong>
                        </td>
                    </tr>
                </tbody>
            ))}
            {(!props.identifiers || props.identifiers.length <= 0) && (
                <tbody key="otherId" className={styles.identifiers}>
                    <tr>
                        <td className="c1" />
                        <td className="c2">
                            <strong data-cy="patientProfile-otherId">--</strong>
                        </td>
                    </tr>
                </tbody>
            )}
        </table>
    );
}

export { OtherIdentifiersView };
